<template>
  <div class="scorm" @touchstart="clickApp">
    <header class="n-fixed-top">
      <div class="left" @click="routerGoBack">
        <div class="n-back"></div>
      </div>
      <h4>{{ title }}</h4>
      <div class="right"></div>
    </header>
    <a-spin tip="loading" v-if="loadState" id="loading" size="large">
      <div class="spin-content"></div>
    </a-spin>
    <div class="content">
      <iframe
        :src="scorm_url + '&sso_token=' + token"
        frameborder="0"
        scrolling="auto"
        allowfullscreen="true"
        webkitallowfullscreen="true"
        mozallowfullscreen="true"
        style="width: 100%; height: 100%"
      ></iframe>
      <watermark v-if="moveRange" :position="moveRange"></watermark>
    </div>
    <stagnation-hint
      @touchstart="clickApp"
      v-show="foolproofTime - addictedTime <= 10 && foolproofTime"
    >
      <span>{{ foolproofTime - addictedTime }}秒</span>
    </stagnation-hint>
  </div>
</template>
<script>
import watermark from "components/MyAliplayer/shuiyin";
import stagnationHint from "@/lib/foolproof";
import mixin from "@/lib/defensive";
import { openWS } from "@/utils/lessonws";
export default {
  data() {
    return {
      title: "",
      scorm_url: "",
      //   time:
      //     localStorage.getItem('current') != null
      //       ? localStorage.getItem('current')
      //       : 1,
      //   timer: null,
      moveRange: "",
      // 当前路由长度
      routerHistoryLng: history.length,
      loadState: false,
      token: localStorage.getItem("_user_data_sso_token"),
      company_id: localStorage.getItem("_user_data_company_id"),
      user_id: localStorage.getItem("_user_data_id"),
      tid: this.$route.query.tid,
      rid: this.$route.query.rid,
      cid: this.$route.query.cid,
      sid: this.$route.query.sid || null,
    };
  },
  components: {
    watermark,
    stagnationHint,
  },
  mixins: [mixin],
  created() {
    window.lessonWSOnOpen = function () {
      let json = {
        type: "openLearningTime",
      };
      let str = JSON.stringify(json);
      if (window.lessonWS && window.lessonWS.ws) {
        window.lessonWS.ws.send(str);
      }
    };
    openWS(
      {
        token: localStorage.getItem("_user_data_sso_token"),
        company_id: localStorage.getItem("_user_data_company_id"),
        user_id: localStorage.getItem("_user_data_id"),
        trainplan_id: this.$route.query.tid,
        resources_id: this.$route.query.rid,
        scorm_id: this.$route.query.sid || null,
      },
      () => {}
    );

    // 页面刷新和关闭事件计时(不包含返回)
    // window.addEventListener('beforeunload', e => this.statisticDuration())
  },
  mounted() {
    this.scorm_url = sessionStorage.getItem("scorm_url");
    this.title = sessionStorage.getItem("scorm_title");

    this.$nextTick(() => {
      this.init();
      // this.saveChapterRecord();
    });

    // this.timer = setInterval(() => {
    //   console.log('用来数数')
    // }, 1000)
    document.title = this.title;
  },
  methods: {
    init() {
      // 获取水印的移动范围 (水印的开关)
      this.MoveRange();
    },
    MoveRange() {
      let boxW = $(".content").width();
      let boxH = $(".content").height();
      this.moveRange = { x: boxW, y: boxH };
    },
    //  记录课程章节
    saveChapterRecord() {
      let _this = this;
      let url = "index.php/mobile/study/save-chapter-record";

      let params = {
        trainplan_id: _this.tid,
        resources_id: _this.rid,
        chapter_id: _this.cid,
        scorm_id: _this.sid,
        sys_id: localStorage.getItem("_sys_id"),
        company_id: localStorage.getItem("_user_data_company_id"),
        user_id: localStorage.getItem("_user_data_id"),
        not_start_except: 1,
        expire_except: 1,
        sso_token: localStorage.getItem("_user_data_sso_token"),
        language: localStorage.getItem("_user_data_language"),
      };
      _this.$axios.post(url, params).then();
    },
    routerGoBack() {
      this.loadState = true;
      if (window.history.length > 1) {
        let len = this.routerHistoryLng - history.length - 1; // -1是不进入iframe页面的下级页面直接退出的话，执行后退一步的操作
        if (this.routerHistoryLng > 2) {
          this.$router.go(len);
        } else {
          this.$router.replace({
            name: "Index",
          });
        }
      } else {
        this.$router.replace({
          name: "Index",
        });
      }
    },
    // 统计入库一波学习时长
    statisticDuration() {
      //   console.log('统计一波时长')
      return new Promise((resolve) => {
        let json = {
          type: "statisticDuration",
        };
        let str = JSON.stringify(json);
        window.lessonWS.ws.send(str);
        resolve();
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    // console.log('beforeRouteLeave--scorm')
    this.statisticDuration();
    // clearInterval(this.timer)
    // this.timer = null
    next();
  },
  //   beforeDestroy () {
  //     console.log('beforeDestroy--scorm')
  //     window.removeEventListener('beforeunload', e => this.statisticDuration())
  //     clearInterval(this.timer)
  //     this.timer = null
  //   }
};
</script>
<style scoped lang="less">
.scorm {
  height: 100%;
  .content {
    position: relative;
    height: calc(100% - 0.72rem);
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }
}
</style>
